// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterFilter_footer__CdMKX","btn":"FooterFilter_btn__18TkI","applyBtn":"FooterFilter_applyBtn__2DnKT","resetBtn":"FooterFilter_resetBtn__1uq5f"};